export enum ServicesList {
  PORCELANIZADA = 'Porcelanizado',
  FIBRA = 'Fibra de vidrio',
  LATONERIA = 'Latonería especializada',
  PINTURA = 'Restauracion de pintura automotriz',
  PLASTICO = 'Reparación de todo tipo plásticos',
  SOLDADURA = 'Soldadura General',
}
